import { render, staticRenderFns } from "./auth-registration.vue?vue&type=template&id=734c3cc6&scoped=true"
import script from "./auth-registration.vue?vue&type=script&lang=js"
export * from "./auth-registration.vue?vue&type=script&lang=js"
import style0 from "./auth-registration.vue?vue&type=style&index=0&id=734c3cc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734c3cc6",
  null
  
)

export default component.exports